export class Config {
  static serverUrl = 'https://app-ws-test.overit.it';
  static MSAL_REDIRECT_URI = 'https://app-admin-test.overit.it';
}
